import React, { useEffect, useState } from "react";
import { AnimatePresence } from "framer-motion";

import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import DownloadApp from "./components/DownloadApp";
import StackedCards from "./components/StackedCards";
import Footer from "./components/Footer";
import Reveal from "./components/Reveal";

import "./index.css";

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Ensure full page loads including images/fonts
    const handleLoad = () => {
      setTimeout(() => setLoading(false), 300);  // smooth fade-out
    };

    window.addEventListener("load", handleLoad);
    return () => window.removeEventListener("load", handleLoad);
  }, []);

  return (
    <AnimatePresence>
      {/* {loading ? (
        <div className="loading-screen">
          <div className="loader"></div>
        </div>
      ) : ( */}
        <>
          <Reveal delay={0.1}>
            <Header />
          </Reveal>

          <Reveal delay={0.2}>
            <HeroSection />
          </Reveal>

          <Reveal delay={0.3}>
            <DownloadApp />
          </Reveal>

          <Reveal delay={0.4}>
            <StackedCards />
          </Reveal>

          <Reveal delay={0.5}>
            <Footer />
          </Reveal>
        </>
     {/* )} */}
    </AnimatePresence>
  );
}

export default App;
